export const SESSION_ID_KEY = 'intake_v2_session_id';

/**
 * Check if a value is a valid session ID (non-empty string, not "undefined"/"null")
 */
export function isValidSessionId(id: unknown): id is string {
  return (
    typeof id === 'string' &&
    id.length > 0 &&
    id !== 'undefined' &&
    id !== 'null'
  );
}

/**
 * Get stored session ID from localStorage
 */
export function getStoredSessionId(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const id = localStorage.getItem(SESSION_ID_KEY);
    if (id && !isValidSessionId(id)) {
      localStorage.removeItem(SESSION_ID_KEY);
      return null;
    }
    return id;
  } catch {
    return null;
  }
}

/**
 * Store session ID in localStorage
 */
export function storeSessionId(sessionId: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  if (!isValidSessionId(sessionId)) {
    console.error('Attempted to store invalid session ID:', sessionId);
    return;
  }
  try {
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  } catch (error) {
    console.error('Failed to store session ID:', error);
  }
}

/**
 * Clear session ID in localStorage
 */
export function clearSessionId(): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    localStorage.removeItem(SESSION_ID_KEY);
  } catch (error) {
    console.error('Failed to remove session ID:', error);
  }
}

/**
 * Clear wizard session (removes session ID from localStorage)
 */
export function clearWizardSession(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(SESSION_ID_KEY);
  } catch (error) {
    console.error('Failed to clear wizard session:', error);
  }
}
